export default {
  genericNetworkError: "Couldn't retrieve data",
  authentication: {
    login: {
      formatError:
        "Data provided for login is not valid. Make sure it matches either username/password combination or provider field.",
      responseError: "Logging in Error",
      USERNAME_PARAM_DEPRECATED_MESSAGE: `
        AuthenticationManager.login: Passing the account identifier (email or phone) in a field called 'userName' is deprecated
        The preferred approach is to name it 'username':
        const config = {
          username: "me@starzplay.com",
          password: "my-password"
        };
        sdk.authenticationManager.login(config);`
    },
    signup: {
      GENERIC_ERROR: "Couldn't complete signup",
      AUTOLOGIN_AS_PARAM_DEPRECATED_MESSAGE: `
    AuthenticationManager.signup: Passing autologin as a second parameter is deprecated.
    The preferred approach is to include it as part of the first parameter:
    const config = {
      username: "me@starzplay.com",
      password: "my-password",
      autologin: true
    };
    sdk.authenticationManager.signup(config);`,
      USER_PARAM_DEPRECATED_MESSAGE: `
    AuthenticationManager.signup: Passing the account identifier (email or phone) in a field called 'user' is deprecated
    The preferred approach is to name it 'username:'
    const config = {
      username: "me@starzplay.com",
      password: "my-password"
    };
    sdk.authenticationManager.signup(config);`,
      MISSING_MANDATORY_PHONE_VERIFICATION_CODE:
        "Missing required mobile verification code to complete signup progress through mobile phone."
    },
    playbackToken: {
      formatError: "Invalid body object value (releasePids or protectionScheme not valid or missing)",
      responseError: "Couldn't retrieve playbackToken"
    },
    mediaAccessToken: {
      GENERIC_ERROR: "Couldn't retrieve mediaAccessToken"
    },
    geolocation: {
      NETWORK_REQUESTS_TIMEOUT_CONFIG_DEPRECATED: `
      Passing networkRequestsTimeout is deprecated. Now networkRequestTimeouts.default should be passed instead.
      Additionally it's possible to set more granular timeouts. Other than default, geolocation is also supported:
      const config = {
        networkRequestTimeouts: {
          default: 15000,
          geolocation: 5000 // Will override the default only for geolocation requests
        }
      }
      `
    },
    phoneVerification: {
      MISSING_OR_INVALID_PHONE_NUMBER: "Missing or invalid mobile phone number to be verified."
    },
    usernameCheck: {
      MISSING_OR_INVALID_USERNAME: "Missing or invalid username to be checked."
    }
  },
  player: {
    MISSING_REQUIRED_MANIFEST: "Missing required parameter config.manifest",
    NOT_RETRIEVED_PLAYBACK_TOKEN: "Couldn't retrieve playback token",
    NOT_READ_EXTERNAL_SUBTITLES: "Couldn't read the external subtitles",
    MEDIA_ACCESS_TOKEN_REQUEST_TIMEOUT: "The get media access request timed out",
    PLAYBACK_TOKEN_REQUEST_TIMEOUT: "The playback token request timed out"
  },
  media: {
    INVALID_SEARCH_TERM: "Invalid search query or config try to send a valid search parameters"
  },
  layout: {
    INVALID_LAYOUT_CONFIG:
      "Invalid layout config object provided while calling layout service, check your calling logic"
  },
  mediaList: {
    USER_NOT_LOGGED_IN: "Media list couldn't be retreived user not logged in",
    WRONG_MEDIALIST_PARAMS: "Wrong or missing parameters provided with the media list query"
  },
  feeds: {
    MISSING_CATALOGUE_PARAMS: "Invalid or missing catalogue params can't make a request to catalogue"
  },
  user: {
    GENERIC_ERROR: "Couldn't retrieve user account information",
    COULD_NOT_UPDATE: "Couldn't update the user account with the given information",
    devices: {
      GENERIC_ERROR: "Couldn't retrieve user devices",
      DEVICE_NOT_ADDED: "The device couldn't be added",
      ADD_DEVICE_TIMEOUT: "The add device request timed out"
    },
    parentalControl: {
      INVALID_LEVEL: "Invalid Parental control level",
      PASSWORD_REQUIRED: "The Parental Level change requested requires password"
    },
    INVALID_USER_PREFERENCES: "Invalid User playback params object",
    INVALID_USER_INFO: "User playback preferences couldn't be retreived user not logged in",
    phoneValidation: {
      INVALID_REQUEST_PARAMS: "Missing or invalid parameters received"
    },
    mergeAccount: {
      INVALID_MERGE_ACCOUNT_PARAMS:
        "Missing or invalid parameters received. 'username', 'password', 'socialProvider' and 'socialUserToken' are required"
    },
    resetPasswordValidation: {
      INVALID_RESET_PASSWORD_PARAMS:
        "Missing or invalid parameters received. 'username', 'newPassword', 'confirmationType' and 'confirmationCode' are required"
    }
  },
  billing: {
    GENERIC_ERROR: "Couldn't complete payment activation process",
    MISSING_MANDATORY_PHONE_VERIFICATION_CODE:
      "Missing required mobile verification code to complete payment activation through operator."
  },
  events: {
    WRONG_EVENT_PARAMS: "Wrong or missing parameters provided with the event query",
    EVENT_NOT_ADDED: "The event couldn't be added"
  },
  campaigns: {
    WRONG_CAMPAIGN_PARAMS: "Wrong or missing parameters provided with the campaign query"
  }
};
